import React, { Component } from 'react';
import * as GServ from '../services/GatewayService';
import { CircularProgress } from '@material-ui/core';


class PaymentSuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSpinner: true,
            status: "Please bear with us while we confirm receipt of your application form. Please don't close this page...",
            warning: '',
            mainHeadText: '',
            formDetails: {},
            confirmed: false,
            showError: false,
            newUser: null,
            autoReg: null,
        }
    }
    
    componentDidMount() {
        // console.log('calling checkToken...');
        this.fetchAppReceipt();
    }
    
    render() {
        let missingQparms = false;
        if (!this.props.qparms.token||!this.props.qparms.entry){missingQparms=true}

        return (
            <div style={{maxWidth:900}}>

                {missingQparms&&
                <div>
                    <h3>Technical Error</h3>
                    Unfortunately a technical error was encountered when we tried to process your application.<br/>
                    If this problem persists, please contact us.
                </div>}
                
                {!missingQparms&&
                <div>
                   
                    {!this.state.showSpinner&&
                    <span><h3>{this.state.mainHeadText}</h3></span>} 

                    {this.state.confirmed&&this.state.autoReg&&
                    <div>
                        <p>
                            Payment has been processed, and you are <b>registered</b> for our {this.state.formDetails.application_for} programme.
                        </p>

                        <p>
                            {this.state.newUser&&
                            <span>We will be sending you an email shortly, with your login details for our <a href={this.state.formDetails.auto_register_ldp_link} target={'_top'}><b>Learning Delivery Platform</b></a>.</span>}
                            
                            {!this.state.newUser&&
                            <span>If you haven't registered with us before, we will be sending you an email shortly with your login details for our <a href={this.state.formDetails.auto_register_ldp_link} target={'_top'}><b>Learning Delivery Platform</b></a>.</span>}. Your new course will be available when you next login.

                            {this.state.formDetails.custom_next_steps_message&&
                            <p dangerouslySetInnerHTML={{__html: this.state.formDetails.custom_next_steps_message}}></p>}
                            
                            <br/><br/>
                            If you have any queries, or if there's anything else we can help with, please feel free to contact us - 
                            <br/><br/>
                            <a href={'mailto:' + this.state.formDetails.enquiries_mail}>{this.state.formDetails.enquiries_mail}</a>
                            <br/><br/>
                            <a href={this.state.formDetails.redirect_url} target="_top">Home</a>
                        </p>
                    </div>}

                    {this.state.confirmed&&!this.state.autoReg&&
                    <div>
                        <p>
                            Payment has been processed successfully. You are <b>registered</b> for our {this.state.formDetails.application_for} programme, and our team will be in touch shortly to extend your welcome.
                        </p>

                        <p>
                            If you have any queries, or if there's anything else we can help with, please feel free to contact us - 
                            <br/><br/>
                            <a href={'mailto:' + this.state.formDetails.enquiries_mail}>{this.state.formDetails.enquiries_mail}</a>
                            <br/><br/>
                            <a href={this.state.formDetails.redirect_url}>Home</a>
                        </p>
                    </div>}


                    <hr/>
                    
                    <span id="StatusBar" className="StatusBar">
                        {this.state.showSpinner&&<CircularProgress size={30} />}&nbsp;&nbsp;
                        {this.state.status}
                    </span>

                    {this.state.warning !== ''&&
                    <div>
                        <span className='warningMessage'>{this.state.warning}</span>
                        <p>
                            <a href={'mailto:' + this.state.formDetails.enquiries_mail}>{this.state.formDetails.enquiries_mail}</a>
                            <br/><br/>
                            <a href={this.state.formDetails.redirect_url}>{this.state.formDetails.redirect_url? 'Home' : ''}</a>
                        </p>
                    </div>}

                </div>}
            </div>
        );
    }

    fetchAppReceipt = () => {
        // console.log('Called fetchAppReceipt');
        GServ.confirmReceipt(this.props.qparms.token,this.props.qparms.entry)
        .then(reply => {
            console.log('fetchAppReceipt reply => ',reply);
            if (reply.Result==='Expired'){
                this.setState({showSpinner:false,mainHeadText:'Expired', status:"This online form has unfortunately expired. Our online registration form is usually valid for 24 hours from when it's first generated. You're more than welcome to follow the original links and submit a fresh application, but if you feel you need any assistance please don't hesitate to contact us.",confirmed:false});
            } else if (reply.Result==='Failed'&&reply.Message!=='Unable to contact Gateway Prime Server'){
                this.setState({showSpinner:false,mainHeadText:'Invalid Link', status:'',warning:"We're unable to process your form currently, as it seems to have been submitted via an invalid or unauthorised link. If this problem persists, please contact us.",confirmed:false});
            } else if (reply.Message==='Form not open for entry'){
                this.setState({showSpinner:false,mainHeadText:'Submissions are Closed', status:"Our online form is not currently open for submissions unfortunately. Should you have any queries, please don't hesitate to contact us.", warnning:"",confirmed:false});
            } else if (!reply.Payload) {
                this.setState({showSpinner:false,mainHeadText:'Technical Error', status:'',warning:"We apologise, but we seem to have encountered a technical issue and are unable to process your form at the moment. If this problem persists, please contact us.",confirmed:false});
            } else if (reply.Payload.receipt_status!=='Published'){
                // console.log("Message wasn't published. fetchAppReceipt reply => ",reply);
                this.setState({showSpinner:false,mainHeadText:'Already Processed', status:'',warning:"This application or registration seems to have already been processed (this may be an old link). We're unable to process your form at the moment. If this problem persists, please contact us.",confirmed:false});
            } else if (reply.Result !=='Success' || !reply.Payload.form_has_paygate || !reply.Payload.paygate_url){
                // console.log('fetchAppReceipt reply: caught unkown failure => ',reply);
                this.setState({showSpinner:false,mainHeadText:'Technical Error', status:"", warning:"We apologise, but we're not able to process your form at the moment due to a technical error. If this problem persists, please contact us.",confirmed:false});
            } else {
                //i.e. Confirm receipt result == Success

                if (reply.Payload.auto_register){
                    //Run auto reg routine...
                    console.log('calling auto reg routine...');
                    this.setState({status:'Creating learner profile and registering for ' + reply.Payload.application_for + " programme... Please don't close this page.", formDetails:reply.Payload});
                    GServ.autoRegister(this.props.qparms.token,this.props.qparms.entry)
                    .then(regReply => {
                        // console.log('regReply :>> ', regReply);
                        if (regReply.Result!=="Success"){
                            this.setState({showSpinner:false,mainHeadText:'Technical Error', status:"", warning:"We apologise, but we're not able to process your form at the moment due to a technical error. If this problem persists, please contact us.",confirmed:false});
                            console.log('Error - unable to run registration routine :>> ', regReply);
                        } else {
                            //Reg done!
                            this.setState({showSpinner:false, mainHeadText: "Thank You!", status:'',warning:'', confirmed:true, newUser: regReply.NewUser, autoReg: true});
                        }
                    });
                } else {
                    //Finished, no auto reg required... still update app status and then finalise
                    console.log('Payment successful, no auto reg routine required...');
                    //?
                    
                    this.setState({status:'Creating learner profile and registering for ' + reply.Payload.application_for + " programme... Please don't close this page.", formDetails:reply.Payload});

                    GServ.markAsPaid(this.props.qparms.token,this.props.qparms.entry)
                    .then(regReply => {
                        // console.log('regReply :>> ', regReply);
                        if (regReply.Result!=="Success"){
                            this.setState({showSpinner:false,mainHeadText:'Technical Error', status:"", warning:"We apologise, but we're not able to process your form at the moment due to a technical error. If this problem persists, please contact us.",confirmed:false});
                            console.log('Error - unable to run registration routine :>> ', regReply);
                        } else {
                            this.setState({showSpinner:false, mainHeadText: "Thank You!", status:'',warning:'', confirmed:true, autoReg: false});
                        }
                    });

                }

            }
        });
    }
    
}

export default PaymentSuccess;